// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideSmilePlus as RawLucideSmilePlus } from "lucide-react";
export const LucideSmilePlus = /* @__PURE__ */ createIcon(RawLucideSmilePlus, "LucideSmilePlus", 2);
